import Wizard from '../../pages/emails/wizard/Wizard';
import WizardStart from '../../pages/emails/wizard/Start';
import WizardRecipient from '../../pages/emails/wizard/Recipient';
import WizardTemplate from '../../pages/emails/wizard/Template';
import WizardCompose from '../../pages/emails/wizard/Compose';
import SendEmail from '../../pages/emails/SendEmail.vue';
import {authGuard} from '../guards';

function getRoutes(routePrefix, layout) {

  const isMobile = (layout === 'mobile');
  let basePath = routePrefix === 'library'
    ? '/v2/app/content/emails/wizard'
    : '/v2/mobile/emails/wizard';

  return [
    { // MLD-6403 This is the temporary route.
      path: isMobile ? '/v2/mobile/email/send' : '/v2/app/content/email/send',
      name: `${routePrefix}.send.email`,
      component: SendEmail,
      meta: {
        layout: layout,
        title: 'Send an email',
        allow_restricted_user: true, // MLD-2750
      }
    },
    {
      path: basePath,
      component: Wizard,
      meta: {
        layout: layout,
        title: 'Send an email',
        allow_restricted_user: true, // MLD-2750
      },
      children: [
        {
          path: '',
          name: `${routePrefix}.email.wizard`,
          component: WizardStart,
          meta: {
            layout: layout,
            title: 'Send an email',
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: 'template',
          name: `${routePrefix}.email.wizard.template`,
          component: WizardTemplate,
          meta: {
            layout: layout,
            title: 'Step 1. Select Template',
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: 'recipient',
          name: `${routePrefix}.email.wizard.recipient`,
          component: WizardRecipient,
          meta: {
            layout: layout,
            title: 'Step 2. Select Recipient',
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: 'compose',
          name: `${routePrefix}.email.wizard.compose`,
          component: WizardCompose,
          meta: {
            layout: layout,
            title: 'Step 3. Compose & Send',
            allow_restricted_user: true, // MLD-2750
          },
        },
      ]
    }
  ];
}

export default [
  ...authGuard([
    ...[
      { // MLD-4284
        path: '/v2/app/content/compose',
        redirect: to => {
          return {name: 'library.email.wizard', params: to.params}
        }
      },
      {
        path: '/v2/app/emails/compose',
        //name: 'app.email.compose',
        // MLD-3922 redirect with function
        // @see https://github.com/vuejs/vue-router/blob/dev/examples/redirect/app.js
        redirect: to => {
          return {name: 'mobile.email.wizard', params: to.params}
        }
      },
      {
        path: '/v2/mobile/emails/compose',
        // MLD-3922 redirect with function
        // @see https://github.com/vuejs/vue-router/blob/dev/examples/redirect/app.js
        redirect: to => {
          return {name: 'mobile.email.wizard', params: to.params}
        }
      },
      {
        path: '/v2/app/emails/wizard',
        //name: 'app.email.compose',
        // MLD-3922 redirect with function
        // @see https://github.com/vuejs/vue-router/blob/dev/examples/redirect/app.js
        redirect: to => {
          return {name: 'mobile.email.wizard', params: to.params}
        }
      },
    ],
    ...getRoutes('library', 'content'),
    //...getRoutes('app', 'mobile'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
